import Link from 'next/link';
import { memo } from 'react';

import { SidebarNavigationItem } from '@air/component-sidebar-navigation';
import { UsersIcon } from '@air/design-icons';

import { Routes } from '~/constants/routes';
import { useIsActiveRoute } from '~/hooks/useIsActiveRoute';

export const SidebarNavigationItemPeople = memo(() => {
  const { isActiveRoute } = useIsActiveRoute({ route: Routes.people });

  return (
    <SidebarNavigationItem
      asChild
      data-id="people"
      prefix={<UsersIcon size="sm" />}
      state={isActiveRoute ? 'active' : 'default'}
    >
      <Link href={Routes.people}>People</Link>
    </SidebarNavigationItem>
  );
});

SidebarNavigationItemPeople.displayName = 'SidebarNavigationItemPeople';
